import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// How long a link to a paragraph keeps it in place while the page settles.
const SETTLE_MS = 2000;

const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (typeof window === "undefined") return;
    // A link to one paragraph (/terms#withdrawal, #1094) lands on it. When nothing
    // has that id yet, as on a page whose code is still loading, go to the top.
    const target = hash ? document.getElementById(decodeURIComponent(hash.slice(1))) : null;
    if (!target?.scrollIntoView) {
      window.scrollTo(0, 0);
      return;
    }
    target.scrollIntoView();

    // The page keeps changing height for a moment after it first renders (the language
    // switches, fonts load), which moved the paragraph out of view again. Put it back on
    // each change until the time is up or the reader scrolls on their own.
    let settled = false;
    const stop = () => {
      settled = true;
      observer?.disconnect();
    };
    const observer =
      typeof ResizeObserver === "undefined"
        ? undefined
        : new ResizeObserver(() => {
            if (!settled) target.scrollIntoView();
          });
    observer?.observe(document.body);
    const timer = window.setTimeout(stop, SETTLE_MS);
    const events = ["wheel", "touchstart", "keydown", "mousedown"] as const;
    events.forEach((name) => window.addEventListener(name, stop, { passive: true, once: true }));

    return () => {
      window.clearTimeout(timer);
      stop();
      events.forEach((name) => window.removeEventListener(name, stop));
    };
  }, [pathname, hash]);

  return null;
};

export default ScrollToTop;
